import Icon from '../components/Icon';

const Weather37Colored = Icon(
  'weather-37-colored',
  <>
    <path
      fill="#EDB326"
      fillRule="evenodd"
      d="M12.341 14.332a.75.75 0 0 1 .327 1.01l-1.443 2.825h3.033l-2.265 4.19a.75.75 0 1 1-1.32-.713l1.069-1.977H8.775l2.557-5.008a.75.75 0 0 1 1.01-.327"
      clipRule="evenodd"
    />
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 7.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 15H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
  </>
);

export default Weather37Colored;
